import React from "react";
import "./Commission_Receive.css";
import { Modal, Button } from "react-bootstrap";
import Done_lottie from "../../../../Animation/Done_lottie/Done_lottie";
import { useNavigate } from "react-router-dom";

function Commission_Receive({ ...props }) {
  const navigate = useNavigate();
  return (
    <Modal
     { ...props }
      centered
      size="sm"
      backdrop="static"
      className="Commission_Receive_modal Common_modal"
    >
      <Modal.Body>
        <div className="Commission_Receive">
          <div className="content_holder">
            <div className="done_lottie_holder">
              <Done_lottie />
            </div>
            <h5>Marvelous</h5>
            <p>
              Your Invitation reward has been Settled commission{" "}
              <span>₹0.56</span>
            </p>
          </div>

          <div className="upi_button_wrapper">
            <Button className="btn_register_bg"  onClick={() => navigate("/home")}>
              Confirm
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Commission_Receive;
